var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditWNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34284_48963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33594 2.66406H2.66927C2.31565 2.66406 1.97651 2.80454 1.72646 3.05459C1.47641 3.30464 1.33594 3.64377 1.33594 3.9974V13.3307C1.33594 13.6844 1.47641 14.0235 1.72646 14.2735C1.97651 14.5236 2.31565 14.6641 2.66927 14.6641H12.0026C12.3562 14.6641 12.6954 14.5236 12.9454 14.2735C13.1955 14.0235 13.3359 13.6844 13.3359 13.3307V8.66406",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3359 1.66421C12.6012 1.399 12.9609 1.25 13.3359 1.25C13.711 1.25 14.0707 1.399 14.3359 1.66421C14.6012 1.92943 14.7502 2.28914 14.7502 2.66421C14.7502 3.03929 14.6012 3.399 14.3359 3.66421L8.0026 9.99755L5.33594 10.6642L6.0026 7.99755L12.3359 1.66421Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34284_48963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWNew);
export default __webpack_public_path__ + "static/media/edit-w-new.45d9be2524a2a3c5110d966d25ab8e59.svg";
export { ForwardRef as ReactComponent };